import * as z from "zod";
import { dropConnectorUsage, usageRef } from "../connectorUsages";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const disconnectGitSyncSchema = z.object({
  spaceId: z.string(),
});

export const disconnectGitSync = mutator({
  schema: disconnectGitSyncSchema,
  resolve: {
    space: { kind: "space", from: "spaceId" },
  },
  permissions: [
    {
      permission: "space:manage",
      scopeId: ({ args }) => args.space.id,
    },
  ],
  fn: async ({ tx, args: { space } }) => {
    const [existing] = await tx.run(
      zql.spaceGitRemotes.where("spaceId", space.id)
    );
    if (existing) await tx.mutate.spaceGitRemotes.delete({ spaceId: space.id });

    // configureGitSync records a space_git_remote usage; drop it so the
    // connector isn't left looking "in use" by a disconnected space.
    const ref = usageRef.spaceGitRemote(space.id);
    const [usage] = await tx.run(
      zql.connectedAppUsages.where("type", ref.type).where("refId", ref.refId)
    );
    if (usage) await dropConnectorUsage(tx, usage.connectedAppId, ref);
  },
});
